import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTree = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 21,
	height: 18,
	viewBox: "0 0 21 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M11.625 3.0625H9.375V5.3125H11.625V3.0625ZM9.375 1.375H11.625C12.5391 1.375 13.3125 2.14844 13.3125 3.0625V5.3125C13.3125 6.26172 12.5391 7 11.625 7H11.3438V8.40625H16.6875C17.7422 8.40625 18.6562 9.32031 18.6562 10.375V11.5H18.9375C19.8516 11.5 20.625 12.2734 20.625 13.1875V15.4375C20.625 16.3867 19.8516 17.125 18.9375 17.125H16.6875C15.7383 17.125 15 16.3867 15 15.4375V13.1875C15 12.2734 15.7383 11.5 16.6875 11.5H16.9688V10.375C16.9688 10.2344 16.8281 10.0938 16.6875 10.0938H11.3438V11.5H11.625C12.5391 11.5 13.3125 12.2734 13.3125 13.1875V15.4375C13.3125 16.3867 12.5391 17.125 11.625 17.125H9.375C8.42578 17.125 7.6875 16.3867 7.6875 15.4375V13.1875C7.6875 12.2734 8.42578 11.5 9.375 11.5H9.65625V10.0938H4.3125C4.13672 10.0938 4.03125 10.2344 4.03125 10.375V11.5H4.3125C5.22656 11.5 6 12.2734 6 13.1875V15.4375C6 16.3867 5.22656 17.125 4.3125 17.125H2.0625C1.11328 17.125 0.375 16.3867 0.375 15.4375V13.1875C0.375 12.2734 1.11328 11.5 2.0625 11.5H2.34375V10.375C2.34375 9.32031 3.22266 8.40625 4.3125 8.40625H9.65625V7H9.375C8.42578 7 7.6875 6.26172 7.6875 5.3125V3.0625C7.6875 2.14844 8.42578 1.375 9.375 1.375ZM2.0625 13.1875V15.4375H4.3125V13.1875H2.0625ZM9.375 13.1875V15.4375H11.625V13.1875H9.375ZM16.6875 13.1875V15.4375H18.9375V13.1875H16.6875Z",
		fill: "#38539A"
	})]
});
const ForwardRef = forwardRef(SvgTree);
export { ForwardRef as ReactComponent };
